import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { FC, useState } from 'react';
import { helpers } from '@/services';
import { useGetCurrentUser } from '@/custom-hooks';

const VISIBLE_COUNT = 4;

type propsType = {
};

export const UserAssignmentsMechanics: FC<propsType> = ({ }) => {
    const [expanded, setExpanded] = useState(false);
    const user = useGetCurrentUser();
    //
    const filteredMeetings = user.meetingsWithAssignments
     .filter(m => [...m.avAssignments, ...m.usherAssignments].some(a => a.user?.id === user.id))
     .sort((m1, m2) => new Date(m2.date).getTime() - new Date(m1.date).getTime());
    //
    const hasMore = filteredMeetings.length > VISIBLE_COUNT;
    const visibleMeetings = expanded ? filteredMeetings : filteredMeetings.slice(0, VISIBLE_COUNT);

    return (
        <div className={'my-2'}>
            <h3 className={'mb-3'}>
                Asignaciones mecánicas de las Reuniones:
            </h3>
            {!!visibleMeetings.length ?
                <>
                {visibleMeetings.map(m =>
                    <div key={m.id}>
                        <span className={'fw-bolder me-1'}>
                            {helpers.GetDayOfWeekFromDateString(m.date)} {m.date}
                        </span>
                        {[...m.avAssignments, ...m.usherAssignments].filter(a => a.user?.id === user.id).map(a =>
                            <span key={a.name}>
                                <span className={'fw-bolder me-2'}>
                                    {a.name}
                                </span>
                            </span>
                        )}
                    </div>
                )}
                {hasMore &&
                    <button className={'btn btn-link p-0 mt-1 text-decoration-none'}
                        onClick={() => setExpanded(x => !x)}
                    >
                        {expanded ?
                            <><FaChevronUp className={'me-1'} />Ver menos</>
                            :
                            <><FaChevronDown className={'me-1'} />Ver {filteredMeetings.length - VISIBLE_COUNT} más</>
                        }
                    </button>
                }
                </>
                :
                <h4>
                    Ninguna
                </h4>
            }
        </div>
    );
}
